<div class="add-attachment-list">
  <label class="add-attachment">
    <input class="attachment-input" type="file" (change)="handleAddAttachment($event)" multiple />
    {{ buttonText | translate }}
  </label>
  <div class="attachment-info">
    <span>{{ "ADD_ATTACHMENT.ONLY_PDF" | translate }}</span>
    <span>{{ "ADD_ATTACHMENT.MAX_FILE_SIZE_10_MB" | translate }}</span>
    <span [class.error]="maxFilesNumberError"
      >{{ "ADD_ATTACHMENT.MAX_FILE_NUMBER" | translate }} {{ maxFilesNumber }}</span
    >
    <span>{{ "ADD_ATTACHMENT.MAX_PAGE_NUMBER" | translate }}</span>
  </div>
  <ul class="attachment-list">
    @if (sendedAttachments.length > 0) {
      @for (attachment of sendedAttachments; track attachment; let index = $index) {
        <li class="attachment">
          <span
            class="attachment-name attachment-name--clickable"
            role="button"
            tabindex="0"
            (click)="handleDownloadSendedAttachment(attachment)"
            >{{ index + 1 }}. {{ attachment.file }}</span
          >
          <button
            type="button"
            class="remove"
            (click)="handleRemoveSendedAttachment(index)"
            title="remove button"
          ></button>
        </li>
      }
    }
    @if (attachmentsList.length > 0) {
      @for (attachment of attachmentsList; track attachment; let index = $index) {
        <li class="attachment">
          <span class="attachment-name">{{ index + 1 + sendedAttachments.length }}. {{ attachment.file.name }}</span>
          <button type="button" class="remove" (click)="handleRemoveAttachment(index)" title="remove button"></button>
          @if (!attachment.isValidated) {
            <span class="invalid-file">{{ "ADD_ATTACHMENT.INVALID_FILE" | translate }}</span>
          }
        </li>
      }
    }
  </ul>
</div>
